import React, { useState, useEffect } from 'react'
import { useTheme, styled } from '@mui/material/styles'
import { Select, Chip, Box, FormControl, MenuItem } from '@mui/material'
import InputBase from '@mui/material/InputBase'


const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const BootstrapInput = styled(InputBase)(({ theme }) => ({
    '& .MuiInputBase-input': {
        position: 'relative',
        backgroundColor: (theme.vars ?? theme).palette.background.paper,
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        '&:focus': {
            borderColor: '#80bdff',
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
        },
    },
}));

function getStyles(option, selection, theme) {
    // console.log('option', option)
    // console.log('selection', selection)
    return {
        fontWeight: selection.includes(option)
            ? theme.typography.fontWeightBold
            : theme.typography.fontWeightRegular,
    }
}

export default function SingleSelectChip({ 
    options, 
    selection, 
    handleChange, 
    open, 
    handleOpen, 
    handleClose,
    // handleExit 
}) {
    const theme = useTheme();

    // console.log('options', options)
    // console.log('selection', selection)
    return (
        <>
            <FormControl sx={{ m: 1, width: '100%' }} variant='standard' >
            {/* <Box sx={{ m: 1, width: '100%' }} onClick={(e) => {
                e.stopPropagation()
            }}> */}
                <Select
                    multiple={false}
                    value={selection}
                    onChange={(e) => {
                        handleChange(e)
                    }}
                    input={<BootstrapInput />}
                    open={open}
                    onOpen={handleOpen}
                    onClose={(e) => handleClose(e)}
                    renderValue={(selected) => (
                        <Chip
                            key={selected.id}
                            label={selected.name}
                            sx={{
                                bgcolor: selected.color,
                                color: selected.textColor,
                            }}
                        />
                    )}
                    MenuProps={MenuProps}
                >
                    {options.map((option) => (
                        <MenuItem
                            key={option.id}
                            value={option}
                            style={getStyles(
                                option.name,
                                selection.name,
                                theme
                            )}
                        >
                            {option.name}
                        </MenuItem>
                    ))}
                </Select>
            {/* </Box> */}
            </FormControl>
        </>
    )
}

